import React from 'react';
import { Button, ButtonProps } from 'antd';
import styles from './styles.module.scss';

interface RevButtonProps extends ButtonProps {
  children?: React.ReactNode;
  className?: string;
}

const RevButton: React.FC<RevButtonProps> = ({ 
  children, 
  className, 
  ...props 
}) => {
  return (
    <Button
      type="default"
      size="large"
      ghost={false}
      danger={false}
      shape="default"
      className={`${styles.revButton} ${className || ''}`}
      {...props}
    >
      {children}
    </Button>
  );
};

export default RevButton; 